/* global moment */
export default class LogEntry {
  stamp = 0
  location = ''
  message = ''

  constructor (location, message) {
    const now = new Date()
    const stamp = moment(now).format('YYYY-MM-DD HH:mm:ss')
    this.stamp = stamp
    if (location !== undefined) {
      this.location = location
    }
    if (message !== undefined) {
      this.message = message
    }
  }

  /**
   * @param {string} location
   */
  set setLocation (location) {
    this.location = location
  }

  /**
   * @param {string} message
   */
  set setMessage (message) {
    this.message = message
  }
}
